export const IMAGE_WIDTHS = [360, 475, 540, 720, 900, 1080, 1280, 1440];
